import {snakeCase} from "lodash";
import {isMoment} from "libs/moment";

const getJavaKey = (jsKey) => {
    return snakeCase(jsKey).toUpperCase();
}

const getParamSerializedValue = (value) => {

    if (isMoment(value)) {
        return value.format()
    }
    return value;
}


const applySearchParams = (search = {}, curParams = {}) => {
    let searchIndex = 0;
    Object.keys(search).reduce((prev, cur) => {
        const val = search[cur];
        if (val === 0 || val === false || !!val) {
            prev['filters[' + searchIndex + '].column'] = getJavaKey(cur);
            prev['filters[' + searchIndex + '].value'] = getParamSerializedValue(search[cur]);
            searchIndex++;
        }
        return prev;
    }, curParams);

    return curParams;
}

export default applySearchParams;